<template>
  <div class="popup-block" :class="{'popup-block-settings': screen === 'profilesettings'}">
    <div v-if="screen === 'locked'" class="popup-locked w-100">
      <div class="text-center mb-3">
        <img alt="logo" src="./../assets/img/logo-new.svg" class="logo">
      </div>
      <div class="popup-locked-middle">
        <button class="popup-locked-btn -parent mb-1" @click="onParentBtnClick">
          Parent Dashboard
        </button>
        <button class="popup-locked-btn -kid mb-1" @click="lockDevice">
          {{$lang.messages.kids_mode}}
        </button>
      </div>
      <a class="parent-dashboard-link" @click="onDashboardBtnClick">
        <i class="icon-settings-bold mr-1" ></i> {{$lang.messages.parent_dashboard}}
      </a>
    </div>
    <EnterParentPassword
        v-if="screen === 'passcode'"
        @onBackClick="screen = 'main'"
        :passToCheck="accountPassword"
        :hideBackButton="true"
        @submitSuccess="gotoDashboard"/>
    <div v-if="screen === 'dashboard'" class="popup-dashboard w-100">
      <HeaderPopup/>
      <div class="popup-dashboard-header">
        {{$lang.messages.parent_mode}}
      </div>
      <p class="popup-dashboard-content text-center mb-1">
        {{$lang.messages.app.parent_dashboard_decription}} <a class="free-dashboard-header-link" href="#" @click.prevent="showWelcomeScreen = true">{{$lang.messages.learn_more}}</a>
      </p>
      <div class="popup-dashboard-content">
        <div class="popup-dashboard-content-tabs">
          <div class="popup-dashboard-content-tab" :class="{active: tab === 'kids'}" @click="tab = 'kids'">{{$lang.messages.free_dashboard.tabs.my_kids}}</div>
          <div class="popup-dashboard-content-tab" :class="{active: tab === 'guest'}" @click="tab = 'guest'">{{$lang.messages.free_dashboard.tabs.one_time_session}}</div>
        </div>
        <div class="popup-dashboard-content-block" v-if="tab === 'kids'" >
          <div class="flex mb-1">
            <div class="popup-manage-kid-image">
              <img src="../assets/img/popup-manage-kid.svg" alt="manage kids">
            </div>
            <div class="popup-manage-kid-text text-white">
              <p>{{$lang.messages.free_dashboard.tabs.kids_description}}</p>
            </div>
          </div>
          <div class="dashboard-content" v-if="profiles">
            <div v-if="isPremium" class="dashboard-profile-list">
              <div class="dashboard-profile" :key="name" v-for="(profile, name, index) in profiles">
                <a href="#" class="profile-edit-btn" @click.prevent="openProfile(name, activeProfiles.includes(name))"><i class="icon-settings-bold"></i></a>
                <div class="locked-profile-image" @click="openProfile(name, activeProfiles.includes(name))">
                  <img :src="profile.avatar || $avatars[profile.defaultAvatarId || 13]" alt="avatar">
                </div>
                <div class="locked-profile-name">
                  {{ profile.kidName || 'Kid ' + index }} <br>
                </div>
                <button class="btn btn-main -shadow" :disabled="activeProfiles.includes(name)" @click.stop="lockDeviceWithProfile(name)">
                  <small v-if="activeProfiles.includes(name)">{{$lang.messages.free_dashboard.kids.profile_is_active}}</small>
                  <span v-else>Start <span class="nowrap">{{$lang.messages.kids_mode}}</span></span>
                </button>
              </div>
              <div class="dashboard-profile add-profile pointer" @click="goToAddChild">
                <div>
                  <div class="add-profile-plus">+</div>
                  <div class="add-profile-label">{{$lang.messages.dashboard.profile.add_profile}}</div>
                </div>
              </div>
            </div>
            <div v-else class="dashboard-profile-list">
              <div class="dashboard-profile">
                <a href="#" class="profile-edit-btn" @click.prevent="openProfileSettings('defaultProfileSettings')"><i class="icon-settings-bold"></i></a>
                <div class="locked-profile-image" @click="openProfileSettings('defaultProfileSettings')">
                  <img :src="profiles['defaultProfileSettings'].avatar || $avatars[profiles['defaultProfileSettings'].defaultAvatarId || 13]" alt="avatar">
                </div>
                <div class="locked-profile-name">
                  {{ profiles['defaultProfileSettings'].kidName || 'kid 1' }} <br>
                </div>
                <button class="btn btn-main -shadow"
                        :disabled="activeProfiles.includes('defaultProfileSettings')"
                        @click.stop="lockDeviceWithProfile('defaultProfileSettings')">
                  <small v-if="activeProfiles.includes('defaultProfileSettings')">{{$lang.messages.free_dashboard.kids.profile_is_active}}</small>
                  <span v-else>Start <span class="nowrap">{{$lang.messages.kids_mode}}</span></span>
                </button>
              </div>
              <div class="dashboard-profile add-profile pointer" @click="premiumFeatures = true">
                <div>
                  <div class="add-profile-plus">+</div>
                  <div class="add-profile-label">{{$lang.messages.dashboard.profile.add_profile}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="popup-dashboard-content-block" v-if="tab === 'guest'" >
          <div class="flex mb-1 popup-dashboard-content-tab-header">
            <div class="popup-manage-kid-image">
              <img src="../assets/img/popup-one-time-gear.svg" alt="manage kids">
            </div>
            <p class="popup-manage-kid-text text-white">
              {{$lang.messages.free_dashboard.tabs.one_time_session_description}}
            </p>
          </div>
          <div class="form-group">
            <label class="form-label">{{$lang.messages.free_dashboard.one_time_session.time_limit}}</label>
            <div class="form-control-icon">
              <i class="icon-in-input icon-timer"></i>
              <v-select
                  :searchable="false"
                  :label="sessionLimitOptions.label"
                  :value="sessionLimitOptions.find(item => item.value >= guestProfileAtCurrentDevice.todayDailyLimit)"
                  :clearable="false"
                  @input="changeSessionTimeLimit"
                  :options="sessionLimitOptions">
                <template slot="open-indicator">
                  <svg class="vs__open-indicator" width="20" height="10" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 0.5L5.5 5L10 0.5" stroke="#7D6AED" stroke-width="2"/>
                  </svg>
                </template>
              </v-select>
            </div>
          </div>
          <div class="form-group">
            <div class="form-label">{{$lang.messages.free_dashboard.one_time_session.allowed_sites}}</div>
            <div class="popup-locked-help" :class="{active: guestProfileAtCurrentDevice.links}" @click.prevent="openLinks">
              <div class="popup-locked-help-title">
                <span v-if="allLinksApp || guestProfileAtCurrentDevice.allowAllLinks">
                  <span v-if="guestProfileAtCurrentDevice.allowAllLinks">{{$lang.messages.app.links.allow_all_sites}}</span>
                  <span v-else>{{$lang.messages.free_dashboard.one_time_session.added}} {{allLinksApp.length}} {{$lang.messages.free_dashboard.one_time_session.sites}}</span>
                </span>
                <span v-else>{{$lang.messages.free_dashboard.one_time_session.choose_sites}}</span>
              </div>
              <div class="popup-locked-help-text" v-if="allLinksApp && !guestProfileAtCurrentDevice.allowAllLinks">
                <span v-for="(link, index) in allLinksApp" :key="index">{{link.title || link.name}}<span v-if="index < allLinksApp.length - 1">, </span>
                </span>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="form-label">{{$lang.messages.exit_passcode}}</div>
            <div class="form-control-icon">
              <InputPassword
                  maxLength="4"
                  passwordVisible="true"
                  customplaceholder="Enter your passcode"
                  v-on:changepassword=changePassCode
                  :value="oneTimePassword"/>
              <i class="icon-in-input icon-locked"></i>
            </div>
            <div class="form-error" v-if="passCodeError">
              {{$lang.messages.passcode_error}}
            </div>
          </div>
          <div class="text-center">
            <button class="btn btn-main -shadow" @click="startSession">{{$lang.messages.free_dashboard.one_time_session.start_session}}</button>
          </div>
        </div>
      </div>
      <div class="popup-dashboard-footer" v-if="isPremium" @click="goToPremiumDashboard" >
        <div class="popup-dashboard-footer-large">{{$lang.messages.free_dashboard.footer.parent}}</div> {{$lang.messages.free_dashboard.footer.dashboard}}
        <img src="../assets/img/popup-dashboard.svg" alt="parent dashboard">
      </div>
      <div class="popup-dashboard-content" v-else>
        <div class="pm-dashboard-footer">
          <div>
            <div class="pm-dashboard-title">
              {{$lang.messages.free_dashboard.footer.features}}
            </div>
            <div class="features-labels-list">
              <div class="feature-label">
                <i class="icon-star active"></i>
                {{$lang.messages.free_dashboard.footer.feature_1}}
              </div>
              <div class="feature-label">
                <i class="icon-star active"></i>
                {{$lang.messages.free_dashboard.footer.feature_2}}
              </div>
              <div class="feature-label">
                <i class="icon-star active"></i>
                {{$lang.messages.free_dashboard.footer.feature_3}}
              </div>
            </div>
          </div>
          <div class="labeled-button-wrap">
          <div class="btn-label">{{$lang.messages.parent_dashboard}}</div>
          <button class="btn btn-main -shaped text-heavy" @click="goToPremiumDashboard">
            {{$lang.messages.get_premium}}
          </button>
        </div>
        </div>
      </div>
    </div>
    <div v-if="screen === 'links'" class="w-100">
      <HeaderPopup :showBack="true" v-on:goback="screen = 'dashboard'"/>
      <div class="popup-links">
        <p class="text-md text-bold mb-1">{{$lang.messages.app.links.add_sites_to_allow}}</p>
        <p class="mb-1 text-muted">{{$lang.messages.app.links.add_sites_to_allow_description}}</p>
        <label for="allowAllSites" class="checkbox-custom flex-v-center mb-2">
          <input type="checkbox" id="allowAllSites" :checked="guestProfileAtCurrentDevice.allowAllLinks" @change="toggleAllLinks">
          <span class="checkmark mr-1"></span>
          <span class="checkbox-custom-title">{{$lang.messages.app.links.allow_all_sites}}</span>
        </label>
        <div class="text-bold mb-05">{{$lang.messages.app.links.websites}}</div>
        <div class="links-wrapper">
          <Link
              v-for="link in guestProfileAtCurrentDevice.links"
              :key="link.id"
              v-bind="link"
              v-on:removelink="removeLink"
              v-on:editlink="editLink"
          />
          <div class="text-bold mb-05" v-if="guestProfileAtCurrentDevice.appListings">{{$lang.messages.app.links.applications}}</div>
          <AppItem
              v-for="app in guestProfileAtCurrentDevice.appListings"
              :key="app.packageName"
              v-bind="app"
              v-on:removeapp="removeApp"
              v-on:editapp="openAddApp"
          />
        </div>
        <div class="flex w-100 mt-1 mb-2">
          <button class="btn btn-outline mr-1" @click="openAddApp">
            {{$lang.messages.app.links.add_app}}
          </button>
          <button class="btn btn-outline" @click="openAddLink">
            {{$lang.messages.app.links.add_site}}
          </button>
        </div>
      </div>
      <div class="shortcut-tabs-wrapper">
        <div class="shortcuts-tabs">
          <div v-for="(item, index) in categories" :key="index" class="radio-label shortcut-tab-item"
               :class="{active: activeTab === item}"
               @click="activeTab = item"
          >
            {{item}}
          </div>
        </div>
        <div class="shortcut-tabs-data">
          <div class="popup-link-list">
            <div :key="index"
                 v-for="(link, index) in activeList"
                 class="popup-link flex flex-v-top">
              <div class="popup-link-icon">
                <img :src="'https://www.google.com/s2/favicons?sz=64&domain=' + link.url" :alt="link.title">
              </div>
              <div class="popup-link-content">
                <div class="popup-link-header flex-between">
                  <a :href="link.url" target="_blank" class="popup-link-title text-md">
                    {{link.title}}
                  </a>
                </div>
                <div class="popup-link-text text-sm" :title="link.desc">
                  {{link.desc}}
                </div>
              </div>
              <div class="popup-link-btn" @click="addLinkFromList(link)">+</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Modal v-if="screen === 'addchild'" @hidemodal="goBackFromAddChild" lowheader="true">
      <AddChildPopup
          slot="content"
          v-on:editlink="editLink"
          v-on:showaddlinkmodal="showAddLinkModal = true"
          v-on:closeaddchild="screen = 'dashboard'"/>
    </Modal>
    <PremiumFeaturesModal
        v-if="premiumFeatures"
        :showClose="false"
        v-on:gettrial="showTrial"
        v-on:hidemodal="premiumFeatures = false"
        v-on:goback="premiumFeatures = false"/>
    <AddLinkModal
        :recommended="false"
        :linktitle="editLinkTitle"
        :linkurl="editLinkUrl"
        :linkId="editLinkId"
        :isEdit="editLinkId"
        v-on:addlink="addLink"
        v-on:hidemodal="showAddLinkModal = false; editLinkId = false"
        v-if="showAddLinkModal"/>
    <WelcomeScreens alias="dashboardFreeWelcome"  v-if="showWelcomeScreen" @hidewelcome="showWelcomeScreen = false"/>
  </div>
</template>

<script>

import { mapGetters, mapState } from 'vuex';
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import saveSetting from '../components/mixins/saveSetting'
import HeaderPopup from "@/components/HeaderPopup";
import {recommendedLinksPopup, sessionLimitOptions} from "@/helpers/configs";
import Link from "@/components/Link";
import AddLinkModal from "@/components/AddLinkModal";
import {isFourDigit, reportEvent} from "@/helpers/utils";
import PremiumFeaturesModal from "@/components/PremiumFeaturesModal";
import AddChildPopup from "@/components/AddChildPopup";
import InputPassword from "@/components/InputPassword";
import Modal from "@/components/common/Modal";
import WelcomeScreens from "@/components/WelcomeScreens";
import AppItem from "@/components/AppItem";
import EnterParentPassword from "@/components/EnterParentPassword"

export default {
  name: 'Popup',
  components: {
    EnterParentPassword,
    InputPassword,
    AddChildPopup,
    PremiumFeaturesModal,
    AddLinkModal,
    Link,
    HeaderPopup,
    Modal,
    AppItem,
    WelcomeScreens
  },
  mixins: [saveSetting],
  data: function () {
    return {
      sessionLimitOptions,
      isAndroid: window.Android,
      isMobileView: window.innerWidth <= 768,
      activeProfile: {},
      switchModeDisabled: false,
      locked: false,
     /* guestProfileAtCurrentDevice: this.$store.getters.guestProfileAtCurrentDevice,*/
      screen: window.sessionStorage.getItem('unlocked') || this.$route.query.isRegister ? 'dashboard' : 'locked',
      tab: 'kids',
      passCode: '',
      passCodeError: false,
      showError: false,
      showAddLinkModal: false,
      activeTab: 'Education',
      categories: ['Education', 'Games', 'Video', 'Portal', 'Music'],
      recommendedLinksPopup,
      editLinkTitle: '',
      editLinkUrl: '',
      editLinkId: null,
      premiumFeatures: false,
      profileToChangeLink: null,
      errorInEmail: false,
      showPas: false,
      showWelcomeScreen: !localStorage.getItem('dashboardFreeWelcome'),
      enteredEmail: '',
      oneTimePassword: this.$store.state.accountData.password,
    }
  },
  computed: {
    ...mapGetters({
      profileAtCurrentDevice: 'profileAtCurrentDevice',
      guestProfileAtCurrentDevice: 'guestProfileAtCurrentDevice'
    }),
    ...mapState({
      isPremium: state => state.accountData.isPremium,
      profiles: state => state.accountData.profiles,
      devices: state => state.accountData.devices,
      user: state => state.user,
      currentDeviceID: state => state.currentDeviceID,
      accountPassword: state => state.accountData.password,
      temporaryProfileID: state => state.temporaryProfileID,
    }),
    activeList() {
      return this.recommendedLinksPopup.filter(link => link.category === this.activeTab && (link.age === this.kidAge || link.age === 'all'));
    },
    activeProfiles() {
      const activeProfilesArray = [];
      Object.keys(this.devices).forEach(key => {
        const profileIdAtDevice = this.devices[key].currentProfileID;
        if (profileIdAtDevice) {
          activeProfilesArray.push(profileIdAtDevice);
        }
      })
      return activeProfilesArray;
    },
    allLinksApp(){
      return this.guestProfileAtCurrentDevice.appListings && this.isAndroid ? this.guestProfileAtCurrentDevice.links.concat(this.guestProfileAtCurrentDevice.appListings) : this.guestProfileAtCurrentDevice.links
    }
  },
  mounted() {
    if (this.guestProfileAtCurrentDevice.created) {
      this.saveGuestProfile({
        ...this.guestProfileAtCurrentDevice,
        ...{
          created: false,
          passCode: this.accountPassword
        }
      })
    }
  },
  methods: {
    goBackFromAddChild(){
      this.screen = 'dashboard';
      this.saveProfileSettings(this.temporaryProfileID, null, true);
    },
    openProfileSettings(profile) {
      this.$router.push({
        path: '/profileSettings',
        query: {
          id: profile
        }
      })
    },
    hideWelcomeModal() {
      localStorage.setItem('showWelcome', '1');
      this.showWelcome = false;
    },
    lockDeviceWithProfile(profileId) {
      reportEvent('startKidsMode', {
        isRemote: false,
      });
      this.saveDeviceSettings(this.currentDeviceID,
          {
            locked: true,
            currentProfileID: profileId,
          });
    },
    openLinks(){
      this.screen = 'links'
      window.scrollTo(0,0);
    },
    showPassword () {
      this.errorInEmail = false
      if(this.user.email === this.enteredEmail){
        this.showPas = true
      } else {
        this.errorInEmail = true
      }
    },
    lockDevice() {
      this.locked = true;
      setTimeout(() => {
        reportEvent('startKidsMode', {
          isRemote: false,
        });
        this.saveDeviceSettings(this.currentDeviceID, {locked: true});
      }, 500);
    },
    startSession() {
      if (isFourDigit(this.oneTimePassword)) {
        this.passCodeError = false;
        this.saveGuestProfile({
          dailyLimitUsed: 0,
          passCode: this.oneTimePassword,
        }).then(()=> {
          reportEvent('startKidsMode', {
            isRemote: false,
          });
          this.saveDeviceSettings(this.currentDeviceID,
              {
                locked: true,
                currentProfileID: 'guestProfileAtCurrentDevice',
              });
        })
      } else {
        this.passCodeError = true;
      }
    },
    openProfile(profileId, profileActive) {
      if(!profileActive){
        this.$router.push(`profile/${profileId}`)
      } else {
        this.$dtoast.pop({
          preset: "error",
          heading: "You can't edit already active profile",
        })
      }
    },
    gotoDashboard() {
      this.screen = 'dashboard';
      sessionStorage.setItem('unlocked', '1')
      /*if (this.accountPassword === this.passCode) {
       this.screen = 'dashboard';
       sessionStorage.setItem('unlocked', '1')
      } else {
        this.showError = true;
      }*/
    },
    changeSessionTimeLimit(option){
      this.saveGuestProfile({todayDailyLimit: option.value});
    },
    changePassCode(event){
      this.oneTimePassword = event;
      // this.saveGuestProfile({passCode: event});
    },
    openAddLink(){
      this.showAddLinkModal = true
      this.editLinkTitle = ''
      this.editLinkUrl = ''
      this.editLinkId = null
    },

    openAddApp() {
      if (this.isAndroid) {
        this.isAndroid.onClickAddPhoneApps('guestProfileAtCurrentDevice');
      }
    },
    checkDuplicateLink(url) {
      const index = this.guestProfileAtCurrentDevice.links ? this.guestProfileAtCurrentDevice.links.findIndex(item => item.url === url) : -1;
      return index !== -1
    },
    addLink(link, editLinkId) {
      this.showAddLinkModal = false
      if (this.guestProfileAtCurrentDevice.links && editLinkId) {
        const item = this.guestProfileAtCurrentDevice.links.find(item => item.id === editLinkId);
        if (this.checkDuplicateLink(link.url) && item.title === link.title) {
          this.$dtoast.pop({
            preset: "error",
            heading: `The site ${link.url} already in list`,
          });
        } else {
          Object.assign(item, link);
          this.editLinkId = false;
          this.saveGuestProfile({links: [...this.guestProfileAtCurrentDevice.links]});
          reportEvent('kidsModeLink', {edit: true})
        }
      } else {
        if (this.checkDuplicateLink(link.url)) {
          this.$dtoast.pop({
            preset: "error",
            heading: `The site ${link.url} already in list`,
          });
        } else {
          const newLinksArray = this.guestProfileAtCurrentDevice.links ? [...this.guestProfileAtCurrentDevice.links, link] : [link];
          this.saveGuestProfile({links: newLinksArray});
          reportEvent('kidsModeLink', {add: true})
        }
      }
    },
    addLinkFromList(item){
      const { hostname } = new URL(item.url)
      const icon = 'https://www.google.com/s2/favicons?sz=64&domain=https://'+hostname+''
      const link = {
        id: Date.now(),
        title: item.title,
        url: item.url,
        icon: icon
      }
      this.addLink(link)
    },
    editLink (link) {
      this.editLinkTitle = link.title
      this.editLinkUrl = link.url
      this.editLinkId = link.id
      this.showAddLinkModal = true
    },
    removeLink (link) {
      const clearedLinks = this.guestProfileAtCurrentDevice.links.filter(item => item.id !== link);
      this.saveGuestProfile({links: clearedLinks});
      reportEvent('kidsModeLink', {remove: true, app: true})
    },
    removeApp (name) {
      const clearedApps = this.guestProfileAtCurrentDevice.appListings.filter(item => item.packageName !== name);
      this.saveGuestProfile({appListings: clearedApps});
    },
    toggleAllLinks(e) {
      this.saveGuestProfile({
        allowAllLinks: e.target.checked,
      });
    },
    showTrial(){
      this.premiumFeatures = false
      this.$router.push('/gettrial')
    },
    goToPremiumDashboard(){
      if (this.isPremium) {
        this.$router.push('/dashboard');
      } else {
        this.premiumFeatures = true
      }
    },
    goToAddChild(){
      if(this.isPremium){
        this.screen = 'addchild'
      } else {
        this.premiumFeatures = true
      }
    },
    onParentBtnClick() {
      this.screen = 'passcode';
      if (this.isAndroid) {
        this.screen = 'passcode';
      } else {
        window.open(`${window.location.origin}/app/#/freeDashboard`);
      }
    },
    onDashboardBtnClick() {
      if (this.isAndroid) {
        this.$router.push('/dashboard');
      } else {
        window.open(`${window.location.origin}/app/#/dashboard`);
      }
    },
  }
}
</script>

<style lang="scss">
@import "../assets/styles/themes";
@import "../assets/styles/kid";
@import "../assets/styles/popup";

</style>
